// src/services/environment.ts
const MS_CLIENT_ID = '236a4cde-6e2d-4459-9568-e20c6ede5ad2';
const MS_AUTHORITY = 'https://login.microsoftonline.com/organizations';

export const getEnvironmentConfig = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0] || ''; // Garante que subdomain não seja undefined

  // Desenvolvimento Local (localhost)
  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    const AUTH_CALLBACK_ORIGIN = 'http://localhost:5173';
    return {
      BASE_URL_BACKEND: `http://${subdomain}.localhost:8080/dev`,
      BASE_URL_FRONTEND: `http://${subdomain}.localhost:5173`,
      SUBDOMAIN: subdomain,
      ENV: "development",
      API_CONTEXT: 'dev',
      AUTH_CALLBACK_ORIGIN,
      AUTH_CALLBACK_URL: `${AUTH_CALLBACK_ORIGIN}/auth/microsoft/callback`,
      MS_CLIENT_ID,
      MS_AUTHORITY,
    };
  }

  // Dev (subdomínios específico: dev)
  const devSubdomains = ["dev"];
  if (devSubdomains.includes(subdomain) && hostname.endsWith("blueltsystem.com.br")) {
    const AUTH_CALLBACK_ORIGIN = 'https://auth.blueltsystem.com.br';
    return {
      BASE_URL_BACKEND: `https://${subdomain}.apiblueltsystem.com.br/dev`,
      BASE_URL_FRONTEND: `https://${subdomain}.blueltsystem.com.br`,
      SUBDOMAIN: subdomain,
      ENV: "dev",
      API_CONTEXT: 'dev',
      AUTH_CALLBACK_ORIGIN,
      AUTH_CALLBACK_URL: `${AUTH_CALLBACK_ORIGIN}/auth/microsoft/callback`,
      MS_CLIENT_ID,
      MS_AUTHORITY,
    };
  }

  // Teste (subdomínios específicos: test, cliente1)
  const testSubdomains = ["test", "cliente1"];
  if (testSubdomains.includes(subdomain) && hostname.endsWith("blueltsystem.com.br")) {
    const AUTH_CALLBACK_ORIGIN = 'https://auth.blueltsystem.com.br';
    return {
      BASE_URL_BACKEND: `https://${subdomain}.apiblueltsystem.com.br/test`,
      BASE_URL_FRONTEND: `https://${subdomain}.blueltsystem.com.br`,
      SUBDOMAIN: subdomain,
      ENV: "test",
      API_CONTEXT: 'test',
      AUTH_CALLBACK_ORIGIN,
      AUTH_CALLBACK_URL: `${AUTH_CALLBACK_ORIGIN}/auth/microsoft/callback`,
      MS_CLIENT_ID,
      MS_AUTHORITY,
    };
  }

  // Produção (qualquer outro subdomínio em blueltsystem.com.br)
  if (hostname.endsWith("blueltsystem.com.br")) {
    const AUTH_CALLBACK_ORIGIN = 'https://auth.blueltsystem.com.br';
    return {
      BASE_URL_BACKEND: `https://${subdomain}.apiblueltsystem.com.br/prod`,
      BASE_URL_FRONTEND: `https://${subdomain}.blueltsystem.com.br`,
      SUBDOMAIN: subdomain,
      ENV: "production",
      API_CONTEXT: 'prod',
      AUTH_CALLBACK_ORIGIN,
      AUTH_CALLBACK_URL: `${AUTH_CALLBACK_ORIGIN}/auth/microsoft/callback`,
      MS_CLIENT_ID,
      MS_AUTHORITY,
    };
  }

  // Fallback (caso algo inesperado aconteça)
  const AUTH_CALLBACK_ORIGIN = 'https://auth.blueltsystem.com.br';
  return {
    BASE_URL_BACKEND: `https://${subdomain}.apiblueltsystem.com.br`,
    BASE_URL_FRONTEND: `https://${hostname}`,
    SUBDOMAIN: subdomain,
    ENV: "unknown",
    API_CONTEXT: 'prod',
    AUTH_CALLBACK_ORIGIN,
    AUTH_CALLBACK_URL: `${AUTH_CALLBACK_ORIGIN}/auth/microsoft/callback`,
    MS_CLIENT_ID,
    MS_AUTHORITY,
  };
};
